import { authDataGet, apiPatch, apiPost } from './api';

// Custom fields editabile de admin (oglindesc Setările utilizatorului)
export interface AdminUserCustomFields {
  functie: string;
  departament: string;
  telefon: string;
}

// Shape returnat de GET /auth/data/admin/users/:id/profile
export interface AdminUserProfile {
  id: number;
  login: string;
  firstName: string;
  lastName: string;
  email: string;
  admin: boolean;
  status: number;
  customFields: AdminUserCustomFields;
}

// Payload pentru PATCH /auth/data/admin/users/:id
export interface AdminUserUpdate {
  firstname?: string;
  lastname?: string;
  functie?: string;
  departament?: string;
  telefon?: string;
  admin?: boolean;
  status?: number;
}

// Payload pentru POST /auth/data/admin/users (creare cont nou)
export interface CreateUserPayload {
  login: string;
  firstname: string;
  lastname: string;
  mail: string;
  admin: boolean;
  password: string;
  functie?: string;
  departament?: string;
  telefon?: string;
}

interface AdminMutationResponse {
  success: boolean;
  message?: string;
}

/**
 * Obține profilul complet al unui utilizator (admin-only).
 * Oglindește shape-ul din /me/profile.
 */
export async function getUserProfileAdmin(id: number): Promise<AdminUserProfile> {
  return authDataGet<AdminUserProfile>(`/admin/users/${id}/profile`);
}

/**
 * Actualizează datele unui utilizator (admin-only): prenume, nume,
 * funcție, departament, telefon. Nu modifică admin/status/email.
 */
export async function updateUserAdmin(
  id: number,
  data: AdminUserUpdate
): Promise<AdminMutationResponse> {
  return apiPatch<AdminMutationResponse>(`/auth/data/admin/users/${id}`, data);
}

/**
 * Creează un cont nou (admin-only). Backend-ul impune unicitatea login/email
 * (case-insensitive) și întoarce 409 la duplicat, 400 la validare.
 */
export async function createUser(
  data: CreateUserPayload
): Promise<{ success: boolean; id?: number; message?: string }> {
  return apiPost<{ success: boolean; id?: number; message?: string }>(
    '/auth/data/admin/users',
    data
  );
}

/**
 * Setează o parolă nouă pentru un utilizator (admin override, fără parola curentă).
 */
export async function setUserPasswordAdmin(
  id: number,
  newPassword: string
): Promise<AdminMutationResponse> {
  return apiPost<AdminMutationResponse>(`/auth/data/admin/users/${id}/password`, {
    newPassword,
  });
}
